export const mapUserResponse = (response) => ({
  initialized: true,
  userName: response.username,
  userRole: response.user_role,
  orgId: response.organization_id,
  orgName: response.org_name ?? null,
  billPay:
    Boolean(response.bill_pay) && Boolean(response.bill_pay_rollout_enabled),
})
